export const suggestedAddressesResults = {
    data: {
        getSuggestedAddresses: {
            suggestions: [
                {
                    address: 'Billericay Road, Herongate, Brentwood CM13',
                    urlPath: 'herongate/billericay-road'
                },
                {
                    address: 'Billers Chase, Springfield, Chelmsford CM1',
                    urlPath: 'essex/springfield/billers-chase'
                },
                {
                    address: 'Billericay Road, Billericay CM12',
                    urlPath: 'billericay/billericay-road'
                }
            ],
            previousSuggestions: [
                {
                    address: 'Billericay Road, Herongate, Brentwood CM13'
                },
                {
                    address: 'Billericay Road, Billericay CM12'
                }
            ]
        }
    }
};
